<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Find New Pros'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-row class="card-header">
        <tidy-text
          [header]="'Find New Pros'" />
        <tidy-toggle
          [toggled]="enableFindNewPros"
          (toggleChanged)="enableFindNewPros = !enableFindNewPros" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Do you want to find new pros, if yours are not available? Enable this and update your preferences anytime. You set the preferences you want including your training, insurance, and certification requirements.'" />
      </tidy-row>
    </tidy-card>

    <tidy-button
      [text]="'Save Settings'"
      [action]="boundSubmit"
      [class]="'primary'" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
